/**
 * @generated SignedSource<<8a9aec33ad138a8cebd529d62e2a01eb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_IssueFieldLinkRelationshipInlineEditFull_LinkRelationshipInlineEditView_issueRef$data = {
  readonly isRemoteIssue: boolean | null | undefined;
  readonly issueId: string;
  readonly issueType: {
    readonly name: string;
  } | null | undefined;
  readonly key: string;
  readonly webUrl: AGG$URL | null | undefined;
  readonly " $fragmentType": "ui_IssueFieldLinkRelationshipInlineEditFull_LinkRelationshipInlineEditView_issueRef";
};
export type ui_IssueFieldLinkRelationshipInlineEditFull_LinkRelationshipInlineEditView_issueRef$key = {
  readonly " $data"?: ui_IssueFieldLinkRelationshipInlineEditFull_LinkRelationshipInlineEditView_issueRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_IssueFieldLinkRelationshipInlineEditFull_LinkRelationshipInlineEditView_issueRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ui_IssueFieldLinkRelationshipInlineEditFull_LinkRelationshipInlineEditView_issueRef",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "issueId"
    },
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "kind": "ScalarField",
      "name": "isRemoteIssue"
    },
    {
      "kind": "ScalarField",
      "name": "webUrl"
    },
    {
      "concreteType": "JiraIssueType",
      "kind": "LinkedField",
      "name": "issueType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        }
      ]
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "5ff93c29f4e7ae110de337bc54ea1e6e";

export default node;
